<div *ngIf="!!gpsList && gpsList.length > 0">
    <mat-toolbar class="sticky-top mat-elevation-z6">
        <mat-toolbar-row *ngIf="count === 1">
            <span>
                <fa-icon [icon]="iconTrain" [fixedWidth]="true" size="lg"></fa-icon>
                {{ gpsList[0]?.carInit }} {{ gpsList[0]?.carNo }}
                <span class="small">{{
                    gpsList[0]?.sightingDateTime | date : 'yyyy-MM-dd' : 'UTC'
                }}</span>
            </span>
            <span class="fill-remaining-space"></span>
            <span>
                <button mat-button (click)="currentTrip()" [disabled]="count !== 1">
                    <fa-icon [icon]="iconTrain" [fixedWidth]="true" size="lg"></fa-icon> View
                    Current Trip
                </button>
            </span>
        </mat-toolbar-row>
        <mat-toolbar-row *ngIf="count > 1">
            <span> {{ count ?? 0 }} GPS Locations Selected </span>
        </mat-toolbar-row>
    </mat-toolbar>
    <section>
        <div class="container" style="margin-top: 20px">
            <div class="row">
                <div *ngIf="errors && errors.length" class="error-warning">
                    <div *ngFor="let error of errors">{{ error.errorMessage }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <bds-gps-location-map [coordinateList]="gpsList"></bds-gps-location-map>
                </div>
            </div>
        </div>
    </section>
</div>
